export enum Roles {
  CINEMA_OWNER = 'CinemaOwner',
  MANAGER = 'Manager',
  STANDARD_USER = 'StandardUser',
  ADMINISTRATOR = 'Administrator',
  SUPER_ADMINISTRATOR = 'SuperAdministrator',
}
